import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";

import SpareForm from "components/spares/SpareForm";
import { createSpare } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const SpareCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const spare = {
    name: "",
    description: "",
    status: "",
    location: "",
    companyID: me.companyID ?? "",
    serviceOrderID: "",
    equipmentID: "",
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        description,
        status,
        location,
        companyID,
        serviceOrderID,
        equipmentID,
      } = valuesParam;

      setLoading(true);

      await API.graphql({
        query: createSpare.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            description,
            status,
            location,
            companyID,
            serviceOrderID,
            equipmentID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/spares");
    } catch (err) {
      console.log("Create Spare onSubmit", err)
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <SpareForm onSubmit={onSubmit} initialValues={spare} />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Repuesto",
    successAdded: "Repuesto agregado con éxito",
    responses: {},
  },
});

export default SpareCreateForm;
